import api from '../api/api';

export interface MpesaTransaction {
  id: number;
  checkout_request_id: string;
  merchant_request_id?: string;
  subscription_id?: number;
  invoice_id?: number;
  school_id: number;
  school_name?: string;
  amount: number;
  phone_number: string;
  account_reference?: string;
  transaction_description?: string;
  status: 'pending' | 'success' | 'failed' | 'cancelled';
  result_code?: string;
  result_description?: string;
  mpesa_receipt_number?: string;
  transaction_date?: string;
  created_at: string;
  updated_at: string;
}

export interface MpesaStkPushRequest {
  subscription_id?: number;
  invoice_id?: number;
  phone_number: string;
  amount: number;
  account_reference?: string;
  transaction_description?: string;
}

export interface MpesaStkPushResponse {
  success: boolean;
  message: string;
  checkout_request_id?: string;
  merchant_request_id?: string;
  transaction_id?: number;
}

export interface MpesaConfig {
  consumer_key: string;
  consumer_secret: string;
  passkey: string;
  business_shortcode: string;
  environment: string;
  callback_url: string;
  enabled: boolean;
}

export interface MpesaStatus {
  enabled: boolean;
  configured: boolean;
  environment: string;
  business_shortcode: string;
  ready: boolean;
}

// M-Pesa API service functions
export const mpesaService = {
  // Get all M-Pesa transactions
  getTransactions: async (): Promise<MpesaTransaction[]> => {
    const response = await api.get('/mpesa/transactions');
    return response.data as MpesaTransaction[];
  },

  // Get a specific transaction
  getTransaction: async (transactionId: number): Promise<MpesaTransaction> => {
    const response = await api.get(`/mpesa/transactions/${transactionId}`);
    return response.data as MpesaTransaction;
  },

  // Initiate STK Push
    initiateStkPush: async (request: MpesaStkPushRequest): Promise<MpesaStkPushResponse> => {
    const response = await api.post('/mpesa/stk-push', request);      
    return response.data as MpesaStkPushResponse;
  },

  // Query transaction status
  queryTransactionStatus: async (checkoutRequestId: string): Promise<any> => {
    const response = await api.post(`/mpesa/transactions/query-status`, {
      checkout_request_id: checkoutRequestId
    });
    return response.data;
  },

  // Get M-Pesa configuration
  getConfig: async (): Promise<MpesaConfig> => {
    const response = await api.get('/settings/mpesa/config');
    return response.data as MpesaConfig;
  },

  // Update M-Pesa configuration
    updateConfig: async (config: MpesaConfig): Promise<boolean> => {    
    const response = await api.post('/settings/mpesa/config', config);
    return (response.data as any).success;
  },

  // Get M-Pesa status
    getStatus: async (): Promise<MpesaStatus> => {
    const response = await api.get('/settings/mpesa/status');        
    return response.data as MpesaStatus;
  },

  // Test M-Pesa connection
  testConnection: async (): Promise<any> => {
    const response = await api.post('/settings/mpesa/test');
    return response.data;
  },

  // Test STK Push
  testStkPush: async (phoneNumber: string, amount: number): Promise<any> => {
    const response = await api.post('/settings/mpesa/test-stk-push', {
      phone_number: phoneNumber,
      amount: amount
    });
    return response.data;
  },

  // Get subscription payment status
  getSubscriptionPaymentStatus: async (subscriptionId: number): Promise<any> => {
    const response = await api.get(`/mpesa/subscriptions/${subscriptionId}/payment-status`);
    return response.data;
  },

  // Get invoice payment status
  getInvoicePaymentStatus: async (invoiceId: number): Promise<any> => {
    const response = await api.get(`/mpesa/invoices/${invoiceId}/payment-status`);
    return response.data;
  }
};

export default mpesaService; 